export function WarningText({
    text = 'This action cannot be undone.',
}: {
    /**
     * The text for the warning (defaults to 'This action cannot be undone.').
     */
    text?: string;
}) {
    return (
        <div className="py-10" data-cy="delete-component-modal-content">
            <span className="warning-text text-red-1 bold">Warning! </span>
            <span className="warning-text bold"> {text} </span>
        </div>
    );
}
